import React, { useState } from "react";
import PropTypes from "prop-types";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";
import AuthApi from "api/auth";

const ChangePassword = ({ onClose, onSuccess }) => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const validatePasswordStrength = (password) => {
    const minLength = 8;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumbers = /[0-9]/.test(password);
    const hasSpecialChars = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    if (password.length < minLength) {
      return "La contraseña es demasiado corta. Debe tener al menos 8 caracteres.";
    }
    if (!hasUpperCase || !hasLowerCase || !hasNumbers || !hasSpecialChars) {
      return "La contraseña debe incluir letras mayúsculas, minúsculas, números y caracteres especiales.";
    }

    return "";
  };

  const handleChangePassword = async () => {
    try {
      setIsLoading(true);
      setErrorMessage("");
      setSuccessMessage("");

      // Validaciones
      if (newPassword !== confirmPassword) {
        setErrorMessage("Las contraseñas no coinciden");
        return;
      }

      const strengthMessage = validatePasswordStrength(newPassword);
      if (strengthMessage) {
        setErrorMessage(strengthMessage);
        return;
      }

      // Cambiar contraseña usando Clerk
      await AuthApi.ChangePassword(oldPassword, newPassword);

      setSuccessMessage("Contraseña cambiada con éxito.");
      setTimeout(() => {
        onSuccess();
      }, 1500);
    } catch (error) {
      setErrorMessage(error.message || "Error al cambiar la contraseña");
    } finally {
      setIsLoading(false);
    }
  };

  const renderPasswordInput = (value, onChange, show, setShow, placeholder, disabled = false) => (
    <SuiBox mb={2}>
      <SuiInput
        type={show ? "text" : "password"}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        size="large"
        disabled={disabled}
        withIcon={{
          icon: show ? "visibility" : "visibility_off",
          direction: "right",
          color: "secondary",
          onClick: () => !disabled && setShow(!show),
        }}
      />
    </SuiBox>
  );

  return (
    <SuiBox display="flex" flexDirection="column" alignItems="center" width="100%">
      <SuiBox width="60%" display="flex" flexDirection="column">
        {renderPasswordInput(
          oldPassword,
          (e) => setOldPassword(e.target.value),
          showOldPassword,
          setShowOldPassword,
          "Contraseña Antigua",
          isLoading
        )}
        {renderPasswordInput(
          newPassword,
          (e) => {
            setNewPassword(e.target.value);
            if (errorMessage) setErrorMessage("");
          },
          showNewPassword,
          setShowNewPassword,
          "Nueva Contraseña",
          isLoading
        )}
        {renderPasswordInput(
          confirmPassword,
          (e) => setConfirmPassword(e.target.value),
          showConfirmPassword,
          setShowConfirmPassword,
          "Confirmar Nueva Contraseña",
          isLoading
        )}

        <SuiBox display="flex" justifyContent="space-between" width="100%">
          <SuiButton
            onClick={handleChangePassword}
            variant="gradient"
            buttonColor="dark"
            size="small"
            disabled={isLoading}
          >
            {isLoading ? "GUARDANDO..." : "GUARDAR"}
          </SuiButton>
          <SuiButton
            variant="text"
            buttonColor="secondary"
            onClick={onClose}
            size="small"
            disabled={isLoading}
          >
            CANCELAR
          </SuiButton>
        </SuiBox>

        {(errorMessage || successMessage) && (
          <SuiTypography
            color={errorMessage ? "error" : "success"}
            textAlign="center"
            sx={{ fontSize: "0.75rem", mt: 1 }}
          >
            {errorMessage || successMessage}
          </SuiTypography>
        )}
      </SuiBox>
    </SuiBox>
  );
};

ChangePassword.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

export default ChangePassword;
